import $ from 'jquery';
import Sloth from '../../components/Sloth';

// 移动端不启用轮播(教学点竖向排列), 需在 Sloth.init 之前移除组件标记
$(() => {
    if (Sloth.isMobile()) {
        $('.Jxd-carousel').removeAttr('component');
    }
});



/** WEBPACK FOOTER **
 ** ./src/XueLiJiaoYu/Jxd.js
 **/